const SEARCH_PLACEHOLDER = 'キーワードを入力';

export function initGoogleSearchPlaceholder() {
  document.querySelectorAll('.c-g-search, .c-footer__search--form').forEach((container) => {
    const updatePlaceholder = () => {
      container.querySelectorAll('input.gsc-input').forEach((input) => {
        if (input.placeholder !== SEARCH_PLACEHOLDER) {
          input.placeholder = SEARCH_PLACEHOLDER;
        }
      });
    };

    // Google renders asynchronously and may recreate or reset its search inputs.
    const observer = new MutationObserver(updatePlaceholder);
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['placeholder'],
    });
    updatePlaceholder();
  });
}
